// Translation: Interface > Copy button (German)
export default Object.freeze({
	idle: '',
	success: ''
})
